/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import dayjs from "dayjs";
import { http } from "~/services/api";
import { periodDayJs } from "~/services/customers/billingPeriod";
import { Currency } from "~/tools/money/currencies";

type KantorResponse = {
  exchangeRate: number;
  exchangeRateDate: string;
};

export const kantorQuery = (
  currency: Currency,
  baseCurrency = Currency.Eur
) => {
  const month = periodDayJs().format("MM");
  const year = periodDayJs().format("YYYY");
  const url = `${process.env.REACT_APP_KANTOR}v1/rates/${year}/${month}/${baseCurrency}/${currency}`;

  return http<KantorResponse>(url);
};

export function checkCurrencyRateValidity(cachedRate: string | null) {
  if (!cachedRate) {
    return false;
  }
  const { expirationDate } = JSON.parse(cachedRate);
  return expirationDate && dayjs().isBefore(dayjs(expirationDate));
}

export enum CurrencyLSKeys {
  CURRENCY = "Currency",
  RATE = "CurrencyRate",
  DEFAULT_PRIORITY = "isDefaultCurrencyPriority",
}
